import { borderRadius, colors, fontFamily, fontSize, shorthandHelper, spacing } from '@offerzen/pinata-shame'
import { css } from '@emotion/css'

const styles = {
  adminLinksContainer: css({
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    right: 0,
    textAlign: 'center',
  }),
  taraAdminLink: css({
    display: 'block',
    color: colors.white,
    fontSize: fontSize.small,
    fontFamily: fontFamily.body,
    borderRadius: `${borderRadius.default} 0 0 0`,
    padding: shorthandHelper([spacing.small, spacing.extraLarge]),
    textDecoration: 'none',
  }),
  candidatesLink: css({
    backgroundColor: colors.jungleGreen,
  }),
  companiesLink: css({
    backgroundColor: colors.cornflowerBlue,
  }),
  hubspotLink: css({
    backgroundColor: colors.redDamask,
  }),
}

export default styles
